module.exports = __webpack_public_path__ + "static/img/cstSer_bg_01.d1cbfc22.svg";